import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandVoicePopup = loadAsyncComponent(() => import('./View'), 'popup');
